import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import { DataTable } from "primereact/datatable";
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { liveMisApi, misApi } from '../http/http';
import Layout from '../components/Layout';
import { toast } from 'react-toastify';
import { removeToken } from '../store/slices/tokenSlice';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';

const HomePage = () => {
    const { tokenData } = useSelector(state => state?.tokenSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    
   

    const [data, setData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [total, setTotal] = useState(null);
    const [monthYear, setMonthYear] = useState(new Date());

    const handleMonthYearChange = (e) => {
        setMonthYear(e.value);
    };

    const [dates, setDates] = useState({
        to: moment(new Date()).format("yyyy-MM-DD"),
        from: moment().startOf("month").format("YYYY-MM-DD"),
    });

    const [startDateForCalendar, setStartDateForCalendar] = useState(
        moment().startOf("month").toDate()
    );
    const [endDateForCalendar, setEndDateForCalendar] = useState(new Date());

    const convertStartDate = (utcDate) => {
        setStartDateForCalendar(utcDate);
        // setEndDateForCalendar(moment(utcDate).add(30, 'days').toDate());
        setDates({
            ...dates,
            // to: moment(new Date(utcDate)).add(30, "days").format("yyyy-MM-DD"),
            from: moment(new Date(utcDate)).format("yyyy-MM-DD"),
        });
    };

    const convertEndDate = (utcDate) => {
        // setStartDateForCalendar(moment(utcDate).subtract(30, 'days').toDate());
        setEndDateForCalendar(utcDate);
        setDates({
            ...dates,
            // from: moment(new Date(utcDate)).subtract(30, 'days').format("yyyy-MM-DD"),
            to: moment(new Date(utcDate)).format("yyyy-MM-DD")
        });
    };

    console.log(tokenData, 'tokenData...');
    const fetchMis = async () => {
        try {
            setLoading(true);

            const startDate = moment(monthYear).startOf("month").format("YYYY-MM-DD");
            const endDate = moment(monthYear).endOf("month").format("YYYY-MM-DD");

            // const response = await misApi(dates.from, dates.to, tokenData);
            const response = await misApi(startDate, endDate, tokenData);
            console.log(response, 'response...');
            const response2 = response?.data?.result?.filter((item) => {
                if (moment(item?.mis_date).isSameOrBefore(new Date())) {
                    return { ...item }
                }
            })
            setData(response2.reverse());
            fetchLiveMis();

            // const total_subscriptions_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_subscriptions ?? 0),
            //     0
            // );

            // const total_unsubscriptions_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_unsubscriptions ?? 0),
            //     0
            // );

            // const subscription_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.subscription_revenue ?? 0),
            //     0
            // );

            // const renewal_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.renewal_revenue ?? 0),
            //     0
            // );

            // const total_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_revenue ?? 0),
            //     0
            // );

            // setTotal({
            //     mis_date: "Totals",
            //     total_base: "",
            //     total_subscriptions: total_subscriptions_sum.toFixed(2),
            //     total_unsubscriptions: total_unsubscriptions_sum.toFixed(2),
            //     subscription_revenue: subscription_revenue_sum.toFixed(2),
            //     renewal_count: "",
            //     renewal_revenue: renewal_revenue_sum.toFixed(2),
            //     total_revenue: total_revenue_sum.toFixed(2),
            // });


        } catch (error) {
            console.log(error, 'error');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    const fetchLiveMis = async () => {
        try {
            const response = await liveMisApi(tokenData);
            setLoading(false);

            setLiveData(response?.data?.result);

        } catch (error) {
            console.log(error, 'error');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    console.log(data, 'data...');
    useEffect(() => {
         
        fetchMis();
    }, [monthYear]);

    const headerGroup = (
        <ColumnGroup>
            {/* Row 1: Main Groups */}
            <Row>
                <Column header="Date" rowSpan={3} />
                <Column header="Total Active Base" rowSpan={3} />

                <Column header="Unsubscription" colSpan={7} />
                <Column header="Subscription" colSpan={7} />
                <Column header="Charged" colSpan={7} />
                <Column header="Renewals" colSpan={7} />
                <Column header="Revenue" colSpan={4} rowSpan={2} />
            </Row>

            {/* Row 2: Subgroups WEB / USSD */}
            <Row>
                <Column header="WEB" colSpan={3} />
                <Column header="USSD" colSpan={3} />
                <Column header="TOTAL" colSpan={1} rowSpan={2} />
                <Column header="WEB" colSpan={3} />
                <Column header="USSD" colSpan={3} />
                <Column header="TOTAL" colSpan={1} rowSpan={2} />
                <Column header="WEB" colSpan={3} />
                <Column header="USSD" colSpan={3} />
                <Column header="TOTAL" colSpan={1} rowSpan={2} />
                <Column header="WEB" colSpan={3} />
                <Column header="USSD" colSpan={3} />
                <Column header="TOTAL" colSpan={1} rowSpan={2} />
            </Row>

            {/* Row 3: Periods */}
            <Row>
                {/* Unsub - WEB & USSD */}
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />

                {/* Sub - WEB & USSD */}
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />

                {/* Charged - WEB & USSD */}
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />

                {/* Renewals - WEB & USSD */}
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />
                <Column header="Daily" />
                <Column header="Weekly" />
                <Column header="Monthly" />


                   {/* Revenue  */}
                <Column header="Subscriptions" />
                <Column header="Renewals" />
                <Column header="Total" />
                <Column header="Accumulated" />
            </Row>
        </ColumnGroup>
    );

    return (
        <>
            <Layout active={0}>

                <div className={classes.date_containers}>
                    <div className={classes.date_container}>
                        {/* <Calendar
                            value={startDateForCalendar}
                            onChange={(e) => convertStartDate(e.value)}
                            showIcon
                            showButtonBar
                            placeholder="Start Date"
                            style={{ width: "100%" }}
                            maxDate={endDateForCalendar}
                        /> */}

                        <Calendar
                            showIcon
                            showButtonBar
                            placeholder="Month / Year"
                            style={{ width: "100%" }}
                            view="month"
                            dateFormat="mm/yy"
                            value={monthYear}
                            onChange={handleMonthYearChange}
                            maxDate={new Date()}
                        />
                    </div>
                    {/* <div className={classes.date_container}>
                        <Calendar
                            value={endDateForCalendar}
                            onChange={(e) => convertEndDate(e.value)}
                            showIcon
                            // touchUI
                            showButtonBar
                            placeholder="End Date"
                            style={{ width: "100%" }}
                            minDate={startDateForCalendar}
                            maxDate={new Date()}
                        />
                    </div> */}

                    {/* <Button label='Search' onClick={fetchMis} /> */}

                </div>

                <div className={classes.message_container}>
                    {/* <i className="pi pi-info-circle" style={{color:"#1F41BA",fontSize:"18px"}} /> */}
                    <p className={classes.message_title}>Revenue Report</p>
                </div>

                {loading ? <Spinner /> : (
                    <div className={classes.table_container}>

                        <DataTable
                            value={[liveData, ...data]}
                            headerColumnGroup={headerGroup}
                            emptyMessage="No data found"
                            showGridlines
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            // responsiveLayout="scroll"
                            paginator
                            rows={40}
                        >
                            {/* Basic */}
                            <Column field="mis_date_time" body={(rowData) => moment(rowData?.mis_date_time).format("DD-MM-YYYY")} />
                            <Column field="total_active_base" />

                            {/* Unsub */}
                            <Column field="unsub_web_daily" />
                            <Column field="unsub_web_weekly" />
                            <Column field="unsub_web_monthly" />
                            <Column field="unsub_ussd_daily" />
                            <Column field="unsub_ussd_weekly" />
                            <Column field="unsub_ussd_monthly" />
                            <Column field="total_unsubscriptions" />

                            {/* Sub */}
                            <Column field="sub_web_daily" />
                            <Column field="sub_web_weekly" />
                            <Column field="sub_web_monthly" />
                            <Column field="sub_ussd_daily" />
                            <Column field="sub_ussd_weekly" />
                            <Column field="sub_ussd_monthly" />
                            <Column field="total_subscriptions" />

                            {/* Charged */}
                            <Column field="sub_charged_web_daily" />
                            <Column field="sub_charged_web_weekly" />
                            <Column field="sub_charged_web_monthly" />
                            <Column field="sub_charged_ussd_daily" />
                            <Column field="sub_charged_ussd_weekly" />
                            <Column field="sub_charged_ussd_monthly" />
                            <Column field="total_sub_charged" />

                            {/* Renewals */}
                            <Column field="renewal_web_daily" body={(rowData) => rowData?.renewal_web_daily ?? rowData?.ren_web_daily} />
                            <Column field="renewal_web_weekly" body={(rowData) => rowData?.renewal_web_weekly ?? rowData?.ren_web_weekly} />
                            <Column field="renewal_web_monthly" body={(rowData) => rowData?.renewal_web_monthly ?? rowData?.ren_web_monthly} />
                            <Column field="renewal_ussd_daily" body={(rowData) => rowData?.renewal_ussd_daily ?? rowData?.ren_ussd_daily} />
                            <Column field="renewal_ussd_weekly" body={(rowData) => rowData?.renewal_ussd_weekly ?? rowData?.ren_ussd_weekly} />
                            <Column field="renewal_ussd_monthly" body={(rowData) => rowData?.renewal_ussd_monthly ?? rowData?.ren_ussd_monthly} />
                            <Column field="total_renewals" />

                            {/* Revenue */}
                            <Column field="total_sub_revenue" />
                            <Column field="total_renewals_revenue" />
                            <Column field="total_revenue" />
                            <Column field="total_accumulated_revenue" />
                        </DataTable>

                    </div>
                )}


            </Layout>

        </>

    )
}

export default HomePage